import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom React Hook to capture UTM parameters from the URL and store them in sessionStorage.
 * This hook should be called once in the main App.js component.
 */
const useUtmTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaign = params.get("utm_campaign");

    // Store UTM parameters in sessionStorage only if they don't already exist
    // This ensures the original attribution source is preserved.
    if (utmSource && !sessionStorage.getItem("utm_source")) {
      sessionStorage.setItem("utm_source", utmSource);
    }
    if (utmMedium && !sessionStorage.getItem("utm_medium")) {
      sessionStorage.setItem("utm_medium", utmMedium);
    }
    if (utmCampaign && !sessionStorage.getItem("utm_campaign")) {
      sessionStorage.setItem("utm_campaign", utmCampaign);
    }
  }, [location.search]); // Re-run effect if URL search parameters change
};

export default useUtmTracker;
